import api from './api';

export interface Imputable {
    nroCuenta: number;
    nroRubro?: number;
    nomCuenta?: string;
    tipoCuentaImputa?: string;
    descripcioncta?: string | null;
    visibleEn?: string;
    saldo?: number;
}

const imputableService = {
    getImputables: async (): Promise<Imputable[]> => {
        const response = await api.get<Imputable[] | { items: Imputable[] }>('/api/Imputables');
        const data = response.data;
        
        // Si la respuesta es un array directo
        if (Array.isArray(data)) {
            return data;
        }
        
        // Si tiene estructura con items
        if (data && typeof data === 'object' && 'items' in data) {
            return Array.isArray((data as { items: Imputable[] }).items) ? (data as { items: Imputable[] }).items : [];
        }
        
        return [];
    },

    getImputable: async (nroCuenta: number): Promise<Imputable | null> => {
        try {
            const imputables = await imputableService.getImputables();
            return imputables.find(i => i.nroCuenta === nroCuenta) || null;
        } catch (error) {
            console.error('Error al obtener imputable:', error);
            return null;
        }
    }
};

export default imputableService;

